import type { RouteRecordRaw } from 'vue-router'
import {ROUTES} from '@myorg/type-lib'


export const merchantOrderRoute: RouteRecordRaw = {
  path: ROUTES.ALL_ORDER.PATH,
  name: ROUTES.ALL_ORDER.NAME,
  // 使用動態匯入 Wrapper
  component: () => import('@/components/order/OrderListPageWrapper.vue'),
  // props: {
  //   merchantOrderApi: merchantOrderApiImpl
  // }
}